import AbstractListResource from './abstract/abstract-list-resource';
import {Resource, ActionType, PaymentStatus} from 'sdk/src/defines';
import Payment from './items/payment';
import {AttributesType} from '../utility/types';
import {TFunction} from 'react-i18next';
import {DropDownItem} from '../utility/types';

class Payments extends AbstractListResource<Payment> {
    public resourceType: Resource = Resource.PAYMENTS;

    public resourceItemClass: typeof Payment = Payment;

    public allowedActions: ActionType[] = [
        ActionType.LIST,
        ActionType.CREATE,
    ];

    public static statusesForDropDown(t: TFunction, empty?: string): DropDownItem[] {
        const result: DropDownItem[] = [];

        if (empty) {
            result.push({
                label: empty,
                value: null,
            });
        }

        result.push(
            {
                label: t('payments.statusPaid'),
                value: PaymentStatus.PAID,
            },
            {
                label: t('payments.statusUnpaid'),
                value: PaymentStatus.UNPAID,
            },
            {
                label: t('payments.statusCanceled'),
                value: PaymentStatus.CANCELLED,
            },
        );

        return result;
    }

    public export(params?: AttributesType): Promise<any> {
        return this.api().resourceExport(this.resourceType, params);
    }
}

export {Payments, Payment};
export default new Payments();
